import { ReactNode } from "react";
import { Submit } from "@radix-ui/react-form";
import { Button, ButtonVariant } from "./Button";

export const FormSubmit = ({
  children,
  className,
  disabled,
  isLoading,
  fullWidth = true,
  rightIcon,
  variant = "primary",
}: {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  fullWidth?: boolean;
  rightIcon?: ReactNode;
  variant?: ButtonVariant;
}) => {
  return (
    <Submit asChild className={className}>
      <Button
        type="submit"
        variant={variant}
        fullWidth={fullWidth}
        disabled={disabled}
        isLoading={isLoading}
        rightIcon={rightIcon}
      >
        {children}
      </Button>
    </Submit>
  );
};
